import { Image, Paper, Stack, Text } from '@mantine/core';
import { useQrCode } from '../hooks/useQrCode.js';
import { joinUrl } from '../routing.js';
import classes from './JoinPanel.module.css';

/**
 * 参加用の QR コードとルームコード（要件1.2、1.3）。
 *
 * 空席がある間は出しておく。途中参加もこの経路で受ける。
 *
 * 大きさはパネル自身の幅で決める（`JoinPanel.module.css`）。画面の向きによってパネルの
 * 幅が大きく変わるため、固定の大きさではどこかで枠をはみ出す。
 */
export function JoinPanel({ roomCode }: { roomCode: string }): React.ReactElement {
  const url = joinUrl(roomCode);
  const qr = useQrCode(url, 260);

  return (
    <Paper withBorder p="md" radius="md" className={classes.panel} data-testid="join-panel">
      <div className={classes.row}>
        {qr !== null && (
          <Image src={qr} alt="参加用 QR コード" className={classes.qr} radius="sm" fit="contain" />
        )}
        <Stack gap={4} className={classes.text}>
          <Text size="sm" c="dimmed">
            <span className={classes.phrase}>スマホで</span>
            <span className={classes.phrase}>読み取って参加</span>
          </Text>
          <Text className={classes.code} data-testid="join-code">
            {roomCode}
          </Text>
          <Text size="xs" c="dimmed" className={classes.url} data-testid="join-url">
            {url}
          </Text>
        </Stack>
      </div>
    </Paper>
  );
}
